'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _bluebird = require('bluebird');

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: wtf with returned cb ?
/* eslint consistent-return: 0 */

var sessionServicePathname = '/rest/grpc/com.unitedtraders.luna.sessionservice.api.sso.SsoService';

var SessionService = function () {
  function SessionService(authServerUrl, realm, clientId) {
    var timeSkew = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var minValidity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    _classCallCheck(this, SessionService);

    this.logger = _auroraJavascriptUtils.log.getLogger('SessionService');

    this._fullUrl = '' + authServerUrl.replace(/\/+$/, '') + sessionServicePathname;
    this._realm = realm;
    this._clientId = clientId;
    this._timeSkew = timeSkew;
    this._minValidity = minValidity;

    this._refreshQueue = [];
  }

  _createClass(SessionService, [{
    key: 'authorizeByFirstFactor',
    value: function authorizeByFirstFactor(username, password, product, locale) {
      var _this = this;

      return new _bluebird.Promise(function (resolve, reject) {
        _superagent2.default.post(_this._fullUrl + '.authorizeByFirstFactor').send({
          realm: _this._realm,
          clientId: _this._clientId,
          loginOrEmail: username,
          password: password,
          product: product,
          locale: locale
        }).end(function (err, res) {
          return err ? reject(err) : resolve(res.body);
        });
      });
    }
  }, {
    key: 'authorizeBySecondFactor',
    value: function authorizeBySecondFactor(secondFactorRequestId, code) {
      var _this2 = this;

      return new _bluebird.Promise(function (resolve, reject) {
        _superagent2.default.post(_this2._fullUrl + '.authorizeBySecondFactor').send({
          code: code,
          secondFactorRequestId: secondFactorRequestId
        }).end(function (err, res) {
          return err ? reject(err) : resolve(res.body);
        });
      });
    }

    /**
     * This function (kc.updateToken) ported from keycloak-js version 2.2.1
     */

  }, {
    key: 'refreshTokens',
    value: function refreshTokens(tokenParsed, refreshToken, cb) {
      var _this3 = this;

      if (!tokenParsed || !refreshToken) {
        return cb(new Error('No parsed accessToken or refreshToken'));
      }

      var needRefreshToken = false;
      if (this.isTokenExpired(tokenParsed.exp)) {
        needRefreshToken = true;
        this.logger.info('Refreshing token: token expired');
      }

      if (!needRefreshToken) {
        return cb(null, false);
      }

      this._refreshQueue.push(cb);
      if (this._refreshQueue.length === 1) {
        var timeLocal = new Date().getTime();
        _superagent2.default.post(this._fullUrl + '.refreshAuthorization').send({
          realm: this._realm,
          clientId: this._clientId,
          refreshToken: refreshToken
        }).end(function (err, res) {
          if (err) {
            _this3.logger.error('Cannot refresh token');
            return cb(err);
          }

          _this3.logger.info('token refreshed successfully');
          timeLocal = (timeLocal + new Date().getTime()) / 2;

          if (_this3._refreshQueue.length > 1) {
            for (var i = 1; i < _this3._refreshQueue.length; i++) {
              _this3._refreshQueue[i](null, res.body);
            }
          }

          _this3._refreshQueue = [];

          return cb(null, res.body);
        });
      }
    }
  }, {
    key: 'logout',
    value: function logout(refreshToken) {
      var _this4 = this;

      return new _bluebird.Promise(function (resolve, reject) {
        _superagent2.default.post(_this4._fullUrl + '.logout').send({
          realm: _this4._realm,
          clientId: _this4._clientId,
          refreshToken: refreshToken
        }).end(function (err, res) {
          return err ? reject(err) : resolve(res.body);
        });
      });
    }
  }, {
    key: 'isTokenExpired',
    value: function isTokenExpired(tokenExpirationTime) {
      var expiresIn = tokenExpirationTime - Math.ceil(new Date().getTime() / 1000) + this._timeSkew - this._minValidity;
      return expiresIn < 0;
    }
  }]);

  return SessionService;
}();

exports.default = SessionService;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/authorization/SessionService.js
// module id = 1322
// module chunks = 118